export const BASE = '/oauth';
export const CSAS = `${BASE}/csas`;
